import React, { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getUserProfile, graph_i18, select2Styles, yearsOnward } from '../../../helpers/functions_helper';
import { Month, noData, QuarterData, WeekOption } from '../../../utils/data';
import timeSheetsService from '../../../services/time.sheets.service';
import LoadingSpinner from '../../../components/Common/Loader';
import { secondsToTime, serialize } from '../../../utils/utils';
import { formatCurrency } from '../../../utils/formats';
import { useDispatch, useSelector } from 'react-redux';
import { CommonAction } from '../../../store/actions';
import GraphFilters from '../../../components/Chart/Filters';
import Chart from '../../../components/Chart';
import { currentMonth, currentYear } from '../../../common/staticdata';

interface PerUserPerTimeSpentProps extends CartProps {
    filters?: any;
}
const years = yearsOnward();

const PerUserPerTimeSpent: FC<PerUserPerTimeSpentProps> = ({ hideHeading, filters = null }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const userObj = getUserProfile('all-time-sheets');

    const inititalFilter = {
        week: null,
        quarter: null,
        month: currentMonth + '',
        year: currentYear,
        user_id: !(userObj.IS_PARTNER && userObj.IS_SUPER_ADMIN) ? userObj.USER_ID : null
    };

    const { getUserOptionsList } = useSelector((state: any) => ({
        getUserOptionsList: state.Common.GET_USER_OPTIONS_LIST_SUCCESS?.data?.filter((i: any) => !(userObj.IS_PARTNER && userObj.IS_SUPER_ADMIN) ? i.value === userObj.USER_ID : i)
    }))

    const [loading, setLoading] = useState<boolean>(true);
    const [query, setQuery] = useState<string | null>(serialize(inititalFilter));
    const [filter, setFilter] = useState<any>(inititalFilter);

    const [data, setData] = useState<any>({
        series: [],
        options: {
            chart: {
                type: 'bar',
                height: 380,
                stacked: true,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: true
                },
                redrawOnParentResize: false,
                redrawOnWindowResize: false
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            plotOptions: {
                bar: {
                    horizontal: false,
                },
            },
            dataLabels: {
                enabled: false,
            },
            xaxis: {
                categories: [],
                labels: {
                    show: true,
                    trim: true,
                    rotate: -45,
                }
            },
            yaxis: {
                labels: {
                    show: true,
                    formatter: function (value: any) {
                        return secondsToTime(value);
                    }
                },
            },
            tooltip: {
                custom: function (opts: any) {

                    const type = opts?.w?.config?.series[opts?.seriesIndex]?.description[opts?.dataPointIndex] || '';
                    const count = opts?.series[opts?.seriesIndex][opts?.dataPointIndex];
                    const total_count = opts?.w?.config?.series.reduce((total: number, self: any) => total + self.data[opts?.dataPointIndex], 0)
                    const code_name = opts?.w?.config?.xaxis?.categories[opts?.dataPointIndex];
                    const name = opts?.w?.config?.series[opts?.seriesIndex]?.name;
                    return `<div class="mt-2 mt-sm-0 p-1">
                    <p class="text-body fw-bold m-0 p-0">${name}</p>
                    <p class="text-muted mb-1">${type}<span class="badge bg-light ms-1 align-bottom">${code_name}</span></p>
                    <h6>${t("Time spent")}: <span class="badge bg-light me-1 align-bottom">${secondsToTime(count)}</span></h6>
                    <h6>${t("Grand total time spent")}: ${secondsToTime(total_count)}</h6>
                    </div>`;
                },
            },
            legend: {
                position: 'bottom',
                offsetY: 5
            },
            fill: {
                opacity: 1
            },
            noData: noData
        },
    })

    const getChartData = async () => {
        const result = await timeSheetsService.perUserPerTaskTimeSpent(query);
        const local_i18n = graph_i18();
        if (result.data.status === 'success') {
            setData((data: any) => ({
                ...data,
                series: result?.data?.data?.series?.map((i: any) => (i.fees_code !== null && { ...i, time_spent: parseInt(i.time_spent, 10) })),
                options: {
                    ...data.options,
                    xaxis: {
                        ...data.options.xaxis,
                        categories: result?.data?.data?.users,
                    },
                    chart: {
                        ...data.options.chart,
                        locales: [local_i18n],
                        defaultLocale: local_i18n?.name,
                    }
                }

            }));
        }
        setLoading(false);
    }

    const clearWorkAllocationFilter = () => {
        setFilter(inititalFilter);
    }

    useEffect(() => {
        loading && getChartData();
    }, [loading])

    useEffect(() => {
        setQuery(serialize(filter));
        setLoading(true);
    }, [filter])

    useEffect(() => {
        filters && setFilter(filters)
    }, [filters])

    useEffect(() => {
        if (!getUserOptionsList) dispatch(CommonAction.getUserOptionsList());
    }, []);

    return (
        <>
            <div className="d-sm-flex flex-wrap">
                <h4 className="card-title mb-4">{!hideHeading && t("Per user per task time spent")}</h4>

                {/* <div className="ms-auto">
                    {(userObj.IS_PARTNER && userObj.IS_SUPER_ADMIN) &&
                        <Select
                            id="user_id"
                            name="user_id"
                            className="form-select-sm myClassName"
                            styles={select2Styles}
                            placeholder="Select user"
                            options={getUserOptionsList}
                            // value={filter.user_id ? getUserOptionsList?.find((i: any) => i.value === filter.week) : null}
                            onChange={(option: any) => {
                                setFilter((filter: any) => ({
                                    ...filter,
                                    user_id: option?.value
                                }));
                            }}
                        />
                    }
                </div> */}

                <div className="ms-auto">
                    <GraphFilters
                        filter={filter}
                        setFilter={setFilter}
                        clearFilter={clearWorkAllocationFilter}
                        slug='all-time-sheets'
                    />
                </div>
            </div>
            <div className="clearfix"></div>
            <Chart loading={loading} options={data.options} series={data.series} type="bar" height={450} />
        </>
    )
}

export default PerUserPerTimeSpent;